import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.NetSuiteLinesSearchFields', {
    netSuiteCategoryFieldTitle: 'Category',
    netSuiteCategoryFieldPlaceholder: 'Selector category',
    netSuiteAccountFieldTitle: 'Account',
    netSuiteAccountFieldPlaceholder: 'Selector account',
    netSuiteItemFieldTitle: 'Item',
    netSuiteItemFieldPlaceholder: 'Selector item',
    netSuiteDepartmentFieldTitle: 'Department',
    netSuiteDepartmentFieldPlaceholder: 'Selector department',
    netSuiteClassFieldTitle: 'Class',
    netSuiteClassFieldPlaceholder: 'Selector class',
    netSuiteLocationFieldTitle: 'Location',
    netSuiteLocationFieldPlaceholder: 'Selector location',
    netSuiteCustomerFieldTitle: 'Customer',
    netSuiteCustomerFieldTitleExpenseReport: 'Customer: Project',
    netSuiteCustomerFieldPlaceholder: 'Select customer',
    netSuiteTaxCodeFieldTitle: 'Tax code',
    netSuiteTaxCodeFieldPlaceholder: 'Select tax code',
    netSuiteItemsAndExpensesBlockHeader: 'ITEMS AND EXPENSES',
    netSuiteExpensesBlockHeader: 'EXPENSES',
    netSuiteItemsBlockHeader: 'ITEMS',
    netSuiteLinesBlockHeader: 'LINES',
    netSuiteCustomPlaceholder: 'Enter value',
});
